import { Actions, createNamespace } from "../../../../flux/Actions";
import { SensorExcess } from "../../../../rest/Dashboard/interfaces";

const ns = createNamespace('ASSIGN');
export const names = {
    SET_SENSOR_EXCESS: ns('SET_SENSOR_EXCESS'),
    SET_DURATION: ns('SET_DURATION'),
    REJECT_SENSOR_EXCESS: ns('REJECT_SENSOR_EXCESS'),
};

export class AssignPersonActions extends Actions
{
    setSensorExcess = (sensorExcess: SensorExcess) => this.dispatch(names.SET_SENSOR_EXCESS, sensorExcess);
    setDuration = (duration: number) => this.dispatch(names.SET_DURATION, duration);
    reject = () => this.dispatch(names.REJECT_SENSOR_EXCESS);
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Home/AssignPersonActions.ts